import Buttons from './src/index.vue'

Buttons.name = 'HxButtons'

Buttons.install = (Vue) => {
  Vue.component(Buttons.name, Buttons)
}

export default Buttons
